@if (display) {
  <p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')" header="{{title}}" [(visible)]="display" showEffect="fade" [modal]="true" appendTo="body">
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
    <!-- #region BODY -->
    <div class="container-md">
      <div class="ui-grid-row">
        <div class="ui-grid-col-12">
          @for (msg of messages; track msg) { <p-message [severity]="msg.severity" [text]="msg.detail"></p-message> }
        </div>
      </div>
      <!-- NAME -->
      <div class="row mt-3">
        <div class="col-12">
          <label for="wayToPay-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{'general.name' | translate}}
                </label>
          <input type="text" id="wayToPay-name" class="form-control custom-input" [(ngModel)]="entity.name">
        </div>
      </div>
      <!-- ACTIVE -->
      <div class="row mt-3">
        <div class="col-12">
          <label for="wayToPay-enabled" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{'general.active' | translate }}
                </label>
          <input class="form-check-input d-flex justify-content-center align-items-center custom-checkbox"
              type="checkbox" [(ngModel)]="active">
        </div>
      </div>
    </div>
    <!-- #endregion BODY -->
  </div>
<!-- #region FOOTER -->
<ng-template pTemplate="footer">
      <div class="d-flex justify-content-center bd-highlight">
        <div class="p-2 bd-highlight">
          @if (isNew) {
            <div>
              <button class="btn custom-button" (click)="save()" i18n>
                        {{'general.create' | translate}}
                    </button>
            </div>
          }
          @if (!isNew) {
            <div>
              <button class="btn custom-button" (click)="save()" i18n>
                        {{'general.save' | translate}}
                    </button>
            </div>
          }
        </div>
        <div class="p-2 bd-highlight">
          @if (!isNew) {
            <div>
              <button class="btn custom-button" (click)="changeStatus(!active)" i18n>
                        {{'general.changeStatus' | translate}}
                    </button>
            </div>
          }
        </div>
      </div>
    </ng-template>
<!-- #endregion FOOTER -->
</p-dialog>
}